import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceLinkedCms',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'serviceLinkedCmsId',
        'linkedCmsName',
        'serviceLinkedCmsUuid',
        'linkedCmsUrl',
        'deleteButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          serviceLinkedCmsId: '連携CMS ID',
          linkedCmsName: '連携CMS名',
          serviceLinkedCmsUuid: '連携CMS UUID',
          linkedCmsUrl: 'URL',
          deleteButton: ''
        },
        columnsClasses: {
          serviceLinkedCmsId: 'wp-5',
          linkedCmsName: '',
          serviceLinkedCmsUuid: '',
          linkedCmsUrl: '',
          deleteButton: 'wp-5 has-button'
        },
        sortable: [
          'serviceLinkedCmsId',
          'linkedCmsName',
          'serviceLinkedCmsUuid',
          'linkedCmsUrl'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 変更
      deleteTargetId: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceLinkedCms.categoryName,
      serviceName: state => state.serviceLinkedCms.serviceName,

      // model
      linkedCmsMstModel: state => state.serviceLinkedCms.linkedCmsMstModel,
      cmsModel: state => state.serviceLinkedCms.cmsModel,

      // form
      values: state => state.serviceLinkedCms.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    linkedCmsMstList () {
      // 連携CMSマスタから、すでに登録されている連携CMSを除いて返す
      return this.linkedCmsMstModel
        .filter(mst => this.cmsModel.findIndex(item => mst.linkedCmsMstId === item.LinkedCmsMstId) === -1)
        .map(item => {
          return {
            value: item.linkedCmsMstId,
            label: item.linkedCmsName
          }
        })
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpCmsId: {
      get () {
        return this.values.inpCmsId
      },
      set (value) {
        this.setInputValue({
          key: 'inpCmsId',
          value: value
        })
      }
    },

    // validate
    inpCmsIdIsValid () {
      return Validator.validText(this.inpCmsId)
    },
    formIsValid () {
      return this.inpCmsIdIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
      // 削除
      if (this.confirmKey === 'delete') {
        if (to) this.deleteData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceLinkedCms/loadModel',
    }),
    ...mapMutations({
      setInputValue: 'serviceLinkedCms/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let serviceParams = {}
      let linkedCmsMstParams = {}
      let serviceLinkedCmsParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceParams: serviceParams,
        linkedCmsMstParams: linkedCmsMstParams,
        serviceLinkedCmsParams: serviceLinkedCmsParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.cmsModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      this.showConfirm({
        key: 'register',
        title: '',
        body: 'この内容で' + this.categoryName + 'を登録しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          linkedCmsMstId: this.inpCmsId
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceLinkedCms'],
        ['v1ServiceLinkedCmsPost'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '新しい' + this.categoryName + 'の登録',
              body: this.categoryName + 'を登録しました。'
            })

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    deleteData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        serviceLinkedCmsUuid: this.deleteTargetId
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceLinkedCms'],
        ['v1ServiceLinkedCmsDelete'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + 'の削除',
              body: this.categoryName + 'を削除しました。'
            })

            this.deleteTargetId = null

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    deleteItem (props) {
      this.deleteTargetId = props.row.serviceLinkedCmsUuid
      // confirm
      const id = Utility.getObjectArrayValue(this.cmsModel, 'serviceLinkedCmsUuid', this.deleteTargetId, 'serviceLinkedCmsId')
      this.showConfirm({
        key: 'delete',
        title: '',
        body: '「Id : ' + id + '」の' + this.categoryName + 'を削除しますか？',
        acceptLabel: '削除'
      })
    }
  }
}